<template>
  <div>
    <confirm-dialog ref="dialog" />
    <confirm-dialog ref="award">
      <div class="modal-content">
        <img
          class="award-img"
          :src="award.image"
          alt="奖品"
        >
        <p class="">
          恭喜获得
        </p>
        <p class="award-name">
          {{ award.title }}
        </p>
        <p class="award-desc">
          商品已发放至您的账户
        </p>
      </div>
    </confirm-dialog>
  </div>
</template>
<script>
import { env, Native } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { purchaseAward } from '@/api/bounty';
import ConfirmDialog from './dialog';

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    from: {
      type: String,
      default: 'list',
    },
    amount: {
      type: Number,
      default: 0,
    },
    points: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      award: {},
    };
  },
  created() {
    UBT.pageView({
      pageId: 'platform_My_reward_points',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  destroyed() {
    UBT.pageViewOut({
      pageId: 'platform_My_reward_points',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  methods: {
    doExchange(item) {
      if (!item.saleNum || item.saleNum <= 0) {
        Toast.show('该商品库存不足，请兑换其他商品～');
      } else if (this.points < item.cost || this.points === 0) {
        UBT.moduleExpose({
          pageId: 'platform_bounty',
          categoryId: 'platform',
          moduleId: 'Bonus_Insufficient.Popup',
          contentId: 'Bonus_Insufficient.Popup',
          exposureTimes: '1',
          businessInfo: {
            from: this.from,
          },
        });
        this.$refs.dialog.open({
          title: '当前奖励金不足',
          confirmText: '好的',
          showCancel: false,
        }).then(() => {
          // UBT.clickButton({
          //   pageId: 'platform_bounty',
          //   categoryId: 'platform',
          //   buttonName: 'Popup_earn',
          //   businessInfo: {
          //     from: this.from,
          //   },
          // });
          // // 滚动到页面顶部
          // if (window && window.scrollTo && this.from === 'list') {
          //   window.scrollTo(0, 0);
          // }
          // if (this.from === 'detail') {
          //   this.$router.go(-1);
          // }
        }).catch(() => {
          UBT.clickButton({
            pageId: 'platform_bounty',
            categoryId: 'platform',
            buttonName: 'Popup_OK',
            businessInfo: {
              from: this.from,
            },
          });
        });
      } else {
        UBT.moduleExpose({
          pageId: 'platform_bounty',
          categoryId: 'platform',
          moduleId: 'Bonus_confirm.Popup',
          contentId: 'Bonus_confirm.Popup',
          exposureTimes: '1',
          businessInfo: {
            from: this.from,
          },
        });
        this.$refs.dialog.open({
          title: '确定兑换该权益吗？',
          cancelText: '取消',
          confirmText: '立即兑换',
        }).then(async () => {
          const { token, ticket } = await Native.getTokenAndKey();
          let cityCode;
          let adCode;
          try {
            const cityInfo = await Native.getCityInfo();
            cityCode = cityInfo.cityCode;
            adCode = cityInfo.adCode;
          } catch (e) {
            cityCode = '';
            adCode = '';
          }
          try {
            let orderPort = '1';
            if (env.isEasyBikeApp) {
              orderPort = '1';
            }
            if (env.isAliMP || env.isAliMPMonitor) {
              orderPort = '2';
            }
            const res = await purchaseAward({
              token,
              ticket,
              cityCode,
              adCode,
              skuId: item.skuId,
              purchaseNum: 1,
              virtualSalePrice: item.cost,
              payAmount: item.price,
              orderPort,
              virtualType: item.virtualType,
            });
            if (res && res.code === 0) {
              this.exchangeSuccessCallback(item);
            } else {
              Toast.show(res && res.msg);
            }
            UBT.clickButton({
              pageId: 'platform_bounty',
              categoryId: 'platform',
              buttonName: 'Popup1_confirm',
              businessInfo: {
                from: this.from,
              },
            });
          } catch (e) {
            Toast.showError(e);
          }
        }).catch(() => {
          UBT.clickButton({
            pageId: 'platform_bounty',
            categoryId: 'platform',
            buttonName: 'Popup1_cancel',
            businessInfo: {
              from: this.from,
            },
          });
        });
      }
    },
    exchangeSuccessCallback(item) {
      this.$emit('success');
      this.award = {
        title: item.title,
        image: item.image,
      };
      UBT.moduleExpose({
        pageId: 'platform_bounty',
        categoryId: 'platform',
        moduleId: 'Bonus_success.Popup',
        contentId: 'Bonus_success.Popup',
        exposureTimes: '1',
        businessInfo: {
          from: this.from,
        },
      });
      this.$refs.award.open({
        confirmText: '知道了',
        showCancel: false,
      }).then(() => {
        UBT.clickButton({
          pageId: 'platform_bounty',
          categoryId: 'platform',
          buttonName: 'Popup2_OK',
          businessInfo: {
            from: this.from,
          },
        });
        window.location.reload();
      }).catch(() => null);
    },
  },
};
</script>


<style scoped>
.modal-content {
  text-align: center;
  color: #333;
  font-size: 0.18rem;
  font-weight: 500;
}

.award-name {
  color: #ffa526;
  font-size: 0.13rem;
  font-weight: 500;
}

.award-desc {
  font-size: 0.13rem;
  font-weight: 400;
  color: #999;
}

.modal-content > p {
  line-height: 2;
}

.award-img {
  width: 1.7rem;
  height: 1.1rem;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 10px;
}
</style>
